import { render, staticRenderFns } from "./jinchukou.vue?vue&type=template&id=d537c0e6&scoped=true&"
import script from "./jinchukou.vue?vue&type=script&lang=js&"
export * from "./jinchukou.vue?vue&type=script&lang=js&"
import style0 from "./jinchukou.vue?vue&type=style&index=0&lang=css&"
import style1 from "./jinchukou.vue?vue&type=style&index=1&id=d537c0e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d537c0e6",
  null
  
)

export default component.exports